import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withToast } from "../contexts/toastr.context";
import { Button, Loader, TextInput } from "../_components";
import { CommunityService } from "../_service";

import cx from "classnames";
import { useAppService } from "../hooks/use-app-service";
import { Tick } from "../_components/form-controls/tick-component";
import {
  getCommunityAddress,
  MAIN_DOMAIN_SUFFIX,
} from "../_config/helper.config";

export const JOIN_COMMUNITY_PAGE_ROUTE = "/join-community";

function JoinCommunityPageComponent({ user, addToast }) {
  const { analyticsService } = useAppService();

  const [address, setAddress] = useState("");
  const [isCheckingForAvailability, setIsCheckingForAvailability] =
    useState(false);
  const [isAddressAvailable, setIsAddressAvailable] = useState(false);

  // debounced check for address availability
  const checkForAddressAvailability = useCallback(
    debounce((address) => {
      // if address is
      if (/^[A-Za-z0-9-]{3,63}$/.test(address)) {
        setIsCheckingForAvailability(true);
        // check for address
        CommunityService.checkForAddressAvailability(address, user)
          .then(({ addressAvailable }) => {
            // set if the address is available, (means it is exisiting on the platform)
            setIsAddressAvailable(!addressAvailable);
            setIsCheckingForAvailability(false);
          })
          .catch((error) => {
            console.log({ error });
            setIsAddressAvailable(false);
            setIsCheckingForAvailability(false);
          });
      }
    }, 1000),
    []
  );

  return (
    <>
      <div className="CommunitySelectorPage theme-bg-default h-screen pt-20">
        <div className="main-content flex flex-col items-center py-12 pt-24">
          {/* greetings */}
          <div className="text-xl font-semibold mb-2">Join a Community</div>
          <div className="text-lg mb-10 font-light theme-text-subtitle-2">
            Enter the community address
          </div>
          {/* input box */}
          <div className="w-72">
            <div className="font-semibold theme-text-heading-2 mt-4">
              Community Address
            </div>
            <div className="mb-4">
              <div className="flex">
                <div className="w-1/2">
                  <TextInput
                    placeholder="URL"
                    validator={(value) => {
                      if (
                        !/^[A-Za-z0-9][A-Za-z0-9\-]{1,62}[A-Za-z0-9]$/.test(
                          value
                        )
                      ) {
                        return "URL invalid!";
                      } else {
                        setIsAddressAvailable(false);
                      }
                    }}
                    defaultValue={address}
                    className="py-2 focus:outline-none"
                    inputHolderClassName={cx({
                      "border-red-500": !isAddressAvailable,
                      "border-green-500": isAddressAvailable,
                    })}
                    onChange={(value) => {
                      setAddress(value);
                      if (value.length > 2) {
                        if (!isCheckingForAvailability)
                          setIsCheckingForAvailability(true);
                      } else {
                        setIsCheckingForAvailability(false);
                      }
                      checkForAddressAvailability(value);
                    }}
                  />
                </div>
                <div className="w-1/2 p-2 font-semibold mt-3 flex items-start">
                  <span className="pr-4">{MAIN_DOMAIN_SUFFIX}</span>
                  <div className="flex items-center">
                    {isCheckingForAvailability ? (
                      <Loader />
                    ) : (
                      <Tick success={isAddressAvailable} />
                    )}
                    <AddressFAQ />
                  </div>
                </div>
              </div>
            </div>
            <Button
              disabled={!isAddressAvailable}
              className="w-full py-2"
              onClick={() => {
                if (isAddressAvailable) {
                  // mixpanel event
                  analyticsService.track("join-community", {}, (e) => {
                    window.location.href = `https://${getCommunityAddress({
                      address,
                    })}?token=${user.token}`;
                  });
                }
              }}
              label="Proceed"
            />
          </div>
        </div>
      </div>
    </>
  );
}

function AddressFAQ() {
  return (
    <div className="AddressFAQ">
      <span className="address-faq-button flex p-1 text-sm theme-bg-subtitle-2 w-6 h-6 justify-center items-center rounded-full mx-2 cursor-pointer">
        i
      </span>
      <div className="address-faq rounded shadow p-3 theme-bg-surface text-xxs font-light">
        <p>Please ask community owner/referrer for the address.</p>
        <p>
          Address should be a combination of minimum 3 of each, letters, digits
          and hyphen
        </p>
        <p>Address cannot start or end with hyphen.</p>
        <p className="theme-text-danger my-2">
          No spaces, underscores, special characters are allowed
        </p>
        <p className="my-1 p-2 text-xxs theme-bg-default rounded">
          For instance if you choose address <b>rakeshteaches</b>, your
          community url will be <b>rakeshteaches.pensil.in</b>
        </p>
        <p className="my-1">Valid community address example:</p>
        <p className="text-right font-semibold theme-text-heading-1">
          community101
        </p>
        <p className="my-1">Invalid address example: </p>
        <p className="text-right font-semibold theme-text-heading-1">
          -some-new-community
        </p>
        <p className="text-right font-semibold theme-text-heading-1">---</p>
        <p className="text-right font-semibold theme-text-heading-1">
          -community 101-
        </p>
      </div>
    </div>
  );
}

const stp = (state) => ({
  user: state.auth,
});

const dtp = (dispatch) => bindActionCreators({}, dispatch);

const JoinCommunityPage = withToast(
  connect(stp, dtp)(JoinCommunityPageComponent)
);

export default JoinCommunityPage;
